var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMinus2 = function SvgMinus2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "31.185 0 136.06 136.061",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M161.122 74.153a6.1 6.1 0 0 0 6.122-6.123 6.097 6.097 0 0 0-6.122-6.123m0 0H37.308c-3.401 0-6.123 2.722-6.123 6.123s2.722 6.123 6.123 6.123h123.814"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMinus2);
export default ForwardRef;